export default "__VITE_ASSET__DIzYss1o__"